import React, { useState, useEffect, useContext } from "react";
import { getApiService } from "../services/ApiService";
import { Spinner } from "react-bootstrap";
import { GetPayLoad } from "../services/PayLoadStorage";
import { LanguageContext } from "../contexts/LanguageContext";
const STPS2Details = ({ onApiComplete }) => {
    const Payload = GetPayLoad('PayLoad');
    const [stps2Details, setCaseSTPS2Details] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const { pageContent } = useContext(LanguageContext);
    const [overViewContent, setOverViewContent] = useState([]);
    const [genericContent, setGenericContent] = useState([]);
    const [errorFlag, setErrorFlag] = useState(false);

    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const headers = {
        "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
        "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
        "X-Hps-Region"   : Payload?.region,
        "X-Hps-Carrier": Payload?.owning_carrier
    }; 
    useEffect(() => {

        if (pageContent?.overview) {
            setOverViewContent(pageContent.overview);
        }

        if (pageContent?.generic) {
            setGenericContent(pageContent.generic);
        }

        const targetCaseAptcUrl = process.env.REACT_APP_API_CASE_APTC_ENDPOINT;
        getApiService(baseUrl, targetCaseAptcUrl, { cim: Payload?.cim, state: Payload?.state, apiSource: 'aptc' }, headers) /* PMO0004087 CHG0127827 SD47534*/
            .then((response) => {

                setLoading(false);
                if (response?.data?.statusCode !== 200) {
                    setErrorFlag(true);
                }else{
                    const result = response.data.data;
                    setErrorFlag(false);
                    setCaseSTPS2Details(result);
                }
                if (onApiComplete) onApiComplete();
            })
            .catch(error => {
                setLoading(false);
                setErrorFlag(true);
                if (onApiComplete) onApiComplete();
            });
    }, [pageContent]);

    const STPS2columns = [
        (overViewContent?.overview_aptc_prev_year_total_text || '') + ' (' + (stps2Details?.stps2PreviousYearPeriod || '') + ')',
        (overViewContent?.overview_aptc_current_year_cumulative_text || '') + ' (' + (stps2Details?.stps2CurrentYearPeriod || '') + ')',
        (overViewContent?.overview_aptc_current_amount_text || '') + ' (' + (stps2Details?.stps2CurrentMonth || '') + ')'
    ];

    return (

        <>
            {errorFlag && (
                <div className="api-error-msg">
                    {genericContent?.finance_service_error}
                </div>
            )}

            {isLoading && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
                    <Spinner animation="border" role="status" ></Spinner>
                    <div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
                </div>
            )}

            {!isLoading && !errorFlag && stps2Details && (
                <div className="bd-example table-responsive aptc-table">
                    <table className="table table-striped aptc-column">
                        <caption style={{ position: 'absolute', width: '1px', height: '1px', padding: '0', margin: '-1px', overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: '0' }}>
                            {overViewContent?.overview_stps2_title}
                        </caption>
                        <thead className="sticky-top aptc-head">
                            <tr className="aptc-header-row">
                                {
                                    STPS2columns && STPS2columns?.map((item) => <th scope="col">{item}</th>)
                                }
                            </tr>
                        </thead>
                        <tbody className="aptc-tbody">
                            <tr className="aptc-row">
                                <td className="aptc-cell">${stps2Details?.stps2PreviousYearAmount}</td>
                                <td className="aptc-cell">${stps2Details?.stps2CurrentYearAmount}</td>
                                <td className="aptc-cell">${stps2Details?.stps2CurrentAmount}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}
        </>

    )
}
export default STPS2Details;
